exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1UXml{margin-top:-5px;margin-bottom:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;font-weight:600}._3kWzM img{margin-right:5px;width:34px;height:auto}._3RFYH{max-width:260px;background-color:#ffeb3b!important}", ""]);

// exports
exports.locals = {
	"root": "_1UXml",
	"bestStoItem": "_3kWzM",
	"customToolTip": "_3RFYH"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/StoAwards/StoAwards.css
// module id = 1978
// module chunks = 0 15 17 22